import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from '@app/modules/application/pages/main/main.component';
import { SearchPageComponent } from '@app/modules/application/components/search/search-page/search-page.component';
import { ProfilePageComponent } from '@app/modules/social/components/profile/profile-page/profile-page.component';
import { BookingLocalModule } from '@modules/booking/booking-local.module';
import { ModuleAvailableGuard } from '@modules/application/guards/module-available.guard';
import { DocumentsLocalModule } from '@modules/documents/documents-local.module';
import { VirtualIdLocalModule } from '@modules/virtual-id/virtual-id-local.module';
import { ModulesResolve } from '@modules/application/guards/modules.resolve';
import { InscriptionLocalModule } from '@modules/academy/academy-local.module';
import { RecurringPaymentLocalModule } from '@modules/recurring-payments/recurring-payments-local.module';
import { MemberInformationLocalModule } from '@modules/member-information-update/member-information-update-local.module';
import { MemberStateLocalModule } from '@modules/member-state/member-state-local.module';
import { PollLocalModule } from '@modules/polling/polling-local.module';
import { AccountSettingsLocalModule } from '@modules/account-settings/account-settings-local.module';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        resolve: {
            modules: ModulesResolve,
        },
        children: [
            {
                path: '',
                loadChildren: () => import('@app/modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
            },
            // {
            //     path: 'search',
            //     component: SearchPageComponent,
            // },
            // {
            //     path: 'user/:user',
            //     component: ProfilePageComponent,
            // },
            // {
            //     path: 'user',
            //     redirectTo: '',
            // },
            // {
            //     path: 'profile/setting',
            //     loadChildren: () =>
            //         import('@app/modules/web-profile/web-profile.module').then((m) => m.WebProfileModule),
            // },
            {
                path: 'payment',
                loadChildren: () => import('@app/modules/payment/payment.module').then((m) => m.PaymentModule),
            },
            {
                path: 'events',
                loadChildren: () => import('@app/modules/meeting/meeting.module').then((m) => m.MeetingModule),
            },
            {
                path: 'account-settings',
                loadChildren: () =>
                    import('@app/modules/account-settings/account-settings.module').then(
                        (m) => m.AccountSettingsModule
                    ),
                data: {
                    identifier: AccountSettingsLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'polling',
                loadChildren: () => import('@app/modules/polling/polling.module').then((m) => m.PollingModule),
                data: {
                    identifier: PollLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'state',
                loadChildren: () =>
                    import('@app/modules/member-state/member-state.module').then((m) => m.MemberStateModule),
                data: {
                    identifier: MemberStateLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'member-information',
                loadChildren: () =>
                    import('@app/modules/member-information-update/member-information-update.module').then(
                        (m) => m.MemberInformationUpdateModule
                    ),
                data: {
                    identifier: MemberInformationLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'recurring-payments',
                loadChildren: () =>
                    import('@app/modules/recurring-payments/recurring-payments.module').then(
                        (m) => m.RecurringPaymentsModule
                    ),
                data: {
                    identifier: RecurringPaymentLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'booking',
                loadChildren: () => import('@app/modules/booking/booking.module').then((m) => m.BookingModule),
                data: {
                    identifier: BookingLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'inscription',
                loadChildren: () => import('@app/modules/academy/academy.module').then((m) => m.AcademyModule),
                data: {
                    identifier: InscriptionLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'virtual-id',
                loadChildren: () => import('@app/modules/virtual-id/virtual-id.module').then((m) => m.VirtualIdModule),
                data: {
                    identifier: VirtualIdLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
            {
                path: 'documents',
                loadChildren: () => import('@app/modules/documents/documents.module').then((m) => m.DocumentsModule),
                data: {
                    identifier: DocumentsLocalModule.code,
                },
                canActivate: [ModuleAvailableGuard],
            },
        ],
    },
];

export const ApplicationRoutes = routes;

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ApplicationRoutingModule {}
